import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { Breadcrumbs, PageTabs, PageTitle } from 'core/components';
import { IBreadcrumbsItem } from 'core/types';
import {
  AccessList,
  CostingCalculationList,
  PageSubtitle,
  UpdatePricingProfileButton,
  VendorQuoteList,
} from 'pricing/components';
import { CostingProfileDetailsTab, PricingProfilePricingType } from 'pricing/enums';
import { costingProfileListPath } from 'pricing/routes';
import { IPricingProfile } from 'pricing/types';

interface IProps {
  costingProfile: IPricingProfile;
}

export const CostingProfileDetails = ({ costingProfile }: IProps) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const tabs = [
    {
      value: CostingProfileDetailsTab.VENDOR_QUOTES,
      label: t('labelVendorQuotes'),
      content: <VendorQuoteList pricingProfile={costingProfile} />,
    },
    {
      value: CostingProfileDetailsTab.COSTING_CALCULATION,
      label: t('labelCostingCalculation'),
      content: <CostingCalculationList pricingProfile={costingProfile} />,
    },
    {
      value: CostingProfileDetailsTab.ACCESS,
      label: t('labelAccess'),
      content: <AccessList pricingProfile={costingProfile} />,
    },
  ];

  const breadcrumbs: IBreadcrumbsItem[] = [
    {
      text: t('labelCostingProfiles'),
      onClick: () => navigate(costingProfileListPath()),
    },
    {
      text: costingProfile.name,
    },
  ];

  return (
    <>
      <Breadcrumbs breadcrumbs={breadcrumbs} />

      <PageTitle
        title={costingProfile.name}
        subtitle={<PageSubtitle pricingProfile={costingProfile} />}
        buttons={[
          <UpdatePricingProfileButton
            key="updateCostingProfileButton"
            type={PricingProfilePricingType.COSTING}
            pricingProfile={costingProfile}
          />,
        ]}
      />

      <PageTabs
        tabs={tabs}
        defaultTab={CostingProfileDetailsTab.VENDOR_QUOTES}
        ariaLabel="costingProfileDetails"
      />
    </>
  );
};
